<template>
    <vx-expandable-card class="relative bg-white [&>div]:p-0 [&>div]:flex [&>div]:flex-col [&>div]:h-full"
        :class="{ 'cursor-default! pointer-events-none!': props.hasBlockedContent }"
    >
        <template v-slot:content>
            <div
                class="flex sm:flex-row flex-col pr-4 pl-4 sm:pl-6 py-6 items-start gap-4 justify-between sm:items-center border-b border-solid border-t-0 border-x-0 border-slate-100"
                :class="{ 'opacity-20': props.hasBlockedContent }"
            >
                <div class="flex flex-row justify-between w-full" :class="{ 'sm:items-center' : props.modelValue.is_locked && $slots.actions }">
                    <div class="flex gap-1 flex-col grow">
                        <div v-if="FEATURES.contact_groups && !onCorporate()" class="text-sm font-normal">
                            <template v-if="props.modelValue.org_unit_id">Organizational Unit</template>
                            <template v-else-if="props.modelValue.group_id">Group</template>
                            <template v-else><font-awesome-icon widthAuto class="text-amber-400" size="lg" :icon="faCrown"/> Corporate</template>
                        </div>
                        <div class="text-md font-bold">{{ props.modelValue.title }}</div>
                    </div>

                    <vx-badge v-if="props.modelValue.is_locked"  size="2xs" color="slate-black" data-test="locked-badge">
                        Locked
                        <font-awesome-icon widthAuto :icon="faLock" />
                    </vx-badge>
                </div>

                <slot name="actions"></slot>
            </div>

            <div class="flex flex-col gap-2 sm:gap-4 p-4 sm:p-6 relative grow" :class="{ 'opacity-20': props.hasBlockedContent }">
                <div v-if="props.modelValue.description"
                    class="text-slate-500 self-start text-base leading-6 line-clamp-4 sm:pr-16"
                >
                    {{ props.modelValue.description }}
                </div>

                <snippet-preview v-model:nestedModal="nestedModal" :snippet="props.modelValue" />

                <div class="text-sm mt-auto flex flex-col sm:flex-row sm:items-center">
                    <span class="text-slate-500 font-extrabold sm:font-normal">Updated at: </span>
                    <span class="sm:ml-3">{{ dayjs(props.modelValue.updated_at).tz(getClientTz()).format('MMM Do, YYYY h:mm a z') }}</span>
                </div>
            </div>

            <vx-alert v-if="props.hasBlockedContent" color="info" class="max-w-4/5 absolute inset-bs-1/2 inset-s-1/2 transform -translate-x-1/2 -translate-y-1/2" :closeable="false">
                <div class="flex justify-between items-center">
                    <span>Attachments not allowed for your account.</span>
                    <vx-popover hover arrow placement="top">
                        <vx-badge size="2xs" color="amber" class="pointer-events-auto whitespace-nowrap">Set by Corp <font-awesome-icon :icon="faCrown" /></vx-badge>
                        <template v-slot:content>
                            <div class="text-center">
                                This limit has been set<br/> by corporate.
                            </div>
                        </template>
                    </vx-popover>
                </div>
            </vx-alert>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faCrown, faLock } from '@fortawesome/pro-solid-svg-icons';
import { VxExpandableCard, VxAlert, VxPopover, VxBadge } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { inject } from 'vue';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import dayjs from '~/utils/dayjs';
import { getClientTz } from '~/utils/date';
import SnippetPreview from '~/components/snippets/components/SnippetPreview.vue';

const FEATURES = inject('FEATURES');
const { onCorporate } = useCurrentGroup();

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    groupId: String,
    hasBlockedContent: {
        type: Boolean,
        default: false,
    },
});

const nestedModal = defineModel('nestedModal', {
    type: Boolean,
    required: false,
    default: false,
});
</script>
